import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { N500 } from '@atlaskit/theme/colors';
import { ExpandableSectionStateless } from '@atlassian/amkt-common';
import { withAnalytics } from '@atlassian/mpac-analytics';
import React from 'react';
import { makeAnalyticsForInstalledApp } from '../../../../../../../analytics/AppId';
import { ANALYTICS_SUBJECT_ID_USER_GRANT_DETAILS, ExpandableSectionCollapsedEvent, ExpandableSectionExpandedEvent } from '../../../../../../../analytics/Events';
import { resolveFieldWithFallback } from '../../../../../../../utils/common-utils';
import UserGrantContent from './UserGrantContent';
import UserGrantHeading from './UserGrantHeading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class UserGrant extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isExpanded: false
    });
    _defineProperty(this, "toggleIsExpanded", () => {
      this.props.fireAnalyticsEvent(makeAnalyticsForInstalledApp(this.state.isExpanded ? ExpandableSectionCollapsedEvent : ExpandableSectionExpandedEvent, ANALYTICS_SUBJECT_ID_USER_GRANT_DETAILS, this.props.installedApp, {
        userGrant: this.props.userGrant.user.atlassianAccountId
      }).toObject());
      this.setState(_ref => {
        let {
          isExpanded
        } = _ref;
        return {
          isExpanded: !isExpanded
        };
      });
    });
    _defineProperty(this, "renderHeading", () => /*#__PURE__*/_jsx(UserGrantHeading, {
      userGrant: this.props.userGrant
    }));
    _defineProperty(this, "renderContent", () => /*#__PURE__*/_jsx(UserGrantContent, {
      appName: resolveFieldWithFallback(add => add.name, this.props.installedApp.marketplaceAppDetails, this.props.installedApp.details),
      links: this.props.links,
      revokeUserGrant: this.props.revokeUserGrant,
      scopesDescription: this.props.scopesDescription,
      scopesLookup: this.props.scopesLookup,
      userGrant: this.props.userGrant
    }));
    _defineProperty(this, "render", () => this.props.collapsible ?
    /*#__PURE__*/
    _jsx(ExpandableSectionStateless, {
      heading: this.renderHeading(),
      content: this.renderContent(),
      expandCollapsePrimaryColor: N500,
      expandCollapseSize: "large",
      hideHeadingWhenExpanded: false,
      isExpanded: this.state.isExpanded,
      onClick: this.toggleIsExpanded
    }) : /*#__PURE__*/_jsxs("div", {
      children: [this.renderHeading(), this.renderContent()]
    }));
  }
}
export default withAnalytics(UserGrant);